export const formatResultForSegment = (
  data: { label: string; displayValue: boolean | number | string }[]
): Record<string, string> => {
  const formattedObject = data.reduce((acc, item) => {
    if (item.displayValue !== undefined) {
      acc[item.label] = item.displayValue;
    }
    return acc;
  }, {});

  return formattedObject;
};
